import mutations from './mutations';
import actions from './actions';
import getDefaultState from './get-default-state';
import getters from './getters';

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions,
  getters,
};
